module.exports = __webpack_public_path__ + "static/media/overrides.c874dea9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep8/overrides.png
 ** module id = 235
 ** module chunks = 0
 **/